var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"d-flex align-end",attrs:{"height":"60","width":"60","type":"avatar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }